jQuery(document).ready(function ($) {

    //Offer Modal
    setTimeout(function(){
        $('#offermodal').modal('show');
    }, 5000);

    //Single Product page
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        arrows: false,
        dots: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                },
            }
        ]
    });

    //Filter Label
    $('.filter_list').hide();
    $('.filter_top').click(function(){
        $(this).toggleClass('open');
        $(this).parents('.filter_block').find('.filter_list').slideToggle();
    });

    //Pagination
    $('.page-link').click(function(){
        $('.page-link').removeClass('disabled');
        $('.page-link').removeClass('active');
        $(this).addClass('active');
    });

    //label Check radio
    $('.ansblock label').click(function(){
        $(this).parents('.ques_block').find('.ansblock label').removeClass('active');
        $(this).addClass('active');
    });

    $('.var_opt > label').click(function(){
        $(this).parents('.var_opt').find('label').removeClass('active');
        $(this).addClass('active');
    });

    //Dynamic Padding
    function my_dynPad() {
        var marLeft = $(".container").css("margin-left");
        var pad_left = $(".container").css("padding-left");
        marLeft = parseInt(marLeft);
        pad_left = parseInt(pad_left);
        var dyn_space = marLeft + pad_left;
        dyn_space = dyn_space + "px"
        $(".dynamic_left").css("padding-left", dyn_space);
        $(".dynamic_right").css("padding-right", dyn_space);
    }
    my_dynPad();
    $(window).resize(my_dynPad);

    /* humbergur */
    $('.menu-toggle').click(function () {
        $(this).find('.humbergur__menu').toggleClass('active');
        $('body').toggleClass('overlay_bg');
        $(this).siblings('.main_navigation').toggleClass('open');
    });

    function add_container_list() {
        $window_width = jQuery(window).width();
        if ($window_width < 992) {
            $('.main-navigation .menu > li').addClass('container');
        } else {
            $('.main-navigation .menu > li').removeClass('container');
        }
    }
    add_container_list();
    $(window).resize(add_container_list);

    // preoader 
    preloaderFadeOutTime = 600;
    function fadePreloader() {
        var preloader = $('.newLoader1');
        preloader.fadeOut(preloaderFadeOutTime);
    }
    fadePreloader();

    //a tag
    $('a[href="#"]').attr("href", "javascript:void(0)");

    //for sticky bar
    function header_sticky() {
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            $(".site_header").addClass("sticky");
        } else {
            $(".site_header").removeClass("sticky");
        }
    }
    header_sticky();
    $(window).scroll(header_sticky);

    //Offer Slider
    $('.offerslider').slick({
		autoplay: false,
		autoplaySpeed: 2000,
		speed: 800,
		infinite: true,
		slidesToShow: 1, 
		slidesToScroll: 1, 
		arrows: true, 
		dots: false
	});

    //Marquee Slider
    $('.marque_row').slick({
        autoplay: true,
        variableWidth: true,
        autoplaySpeed: 0,
        speed: 5000,
        arrows: false,
        swipe: false,
        cssEase: 'linear',
        pauseOnFocus: false,
        pauseOnHover: false,
        focusOnSelect: false,
        draggable: false,
        accessibility: false,
        swipeToSlide: false
      });

    //Review (Testimonials)
    $('.reviewslider').slick({
		autoplay: false,
		autoplaySpeed: 2000,
		speed: 800,
		infinite: true,
        fade: true,
        cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
        adaptiveHeight: true,
		slidesToShow: 1, 
		slidesToScroll: 1, 
		arrows: true, 
		dots: false,
        responsive: [
            {
                breakpoint: 1320,
                settings: {
                    arrows: false, 
		            dots: true
                },
            },
            {
                breakpoint: 575,
                settings: {
                    arrows: true, 
		            dots: false
                },
            }
        ]
	});

    //Review (Testimonials)
 //    $('.ss_slider').slick({
	// 	autoplay: false,
	// 	autoplaySpeed: 2000,
	// 	speed: 800,
	// 	infinite: true,
	// 	slidesToShow: 1, 
	// 	slidesToScroll: 1, 
	// 	arrows: true, 
	// 	dots: true,
 //        responsive: [
 //            {
 //                breakpoint: 1440,
 //                settings: {
 //                    arrows: false,
 //                    dots: true,
 //                },
 //            }
 //        ]
	// });

    //Latest articel
	$('.latestarticels').slick({
		autoplay: false,
		autoplaySpeed: 2000,
		speed: 800,
		infinite: false,
		slidesToShow: 3, 
		slidesToScroll: 1, 
		arrows: true, 
		dots: false ,
        responsive: [
            {
                breakpoint: 1320,
                settings: {
                    arrows: false, 
		            dots: true
                },
            },
            {
                breakpoint: 992,
                settings: {
                    arrows: false, 
		            dots: true,
                    slidesToShow: 2,
                    slidesToScroll: 1
                },
            },
            {
                breakpoint: 575,
                settings: {
                    arrows: false, 
		            dots: true,
                    slidesToShow: 1.1,
                    slidesToScroll: 1
                },
            }
        ]
	});

    //Best seller
	$('.bestsellerslider').slick({
		autoplay: false,
		autoplaySpeed: 2000,
		speed: 800,
		infinite: false,
		slidesToShow: 3, 
		slidesToScroll: 1, 
		arrows: true, 
		dots: false ,
        responsive: [
            {
                breakpoint: 1320,
                settings: {
                    arrows: false, 
		            dots: true
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                },
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 1.1,
                    slidesToScroll: 1
                },
            }
        ]
	});

    //Blog hero
    $('.blog_heroslider').slick({
		autoplay: false,
		autoplaySpeed: 2000,
		speed: 800,
		infinite: true,
        fade: false,
        adaptiveHeight: true,
		slidesToShow: 1, 
		slidesToScroll: 1, 
		arrows: true, 
		dots: false,
        responsive: [
            {
                breakpoint: 1320,
                settings: {
                    arrows: false, 
		            dots: true
                },
            }
        ]
	});

    //Doctor Slider
    $('.docslider').slick({
		autoplay: false,
		autoplaySpeed: 2000,
		speed: 800,
		infinite: false,
		slidesToShow: 3, 
		slidesToScroll: 1,
		arrows: false, 
		dots: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2, 
		            slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1, 
		            slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                },
            }
        ]
	});

});

